var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.src),expression:"src"}],attrs:{"src":_vm.loadingImage,"alt":_vm.alt}})}
var staticRenderFns = []

export { render, staticRenderFns }